import { render, staticRenderFns } from "./2_product_center_details_1.vue?vue&type=template&id=e5b17c82&scoped=true&"
import script from "./2_product_center_details_1.vue?vue&type=script&lang=js&"
export * from "./2_product_center_details_1.vue?vue&type=script&lang=js&"
import style0 from "./2_product_center_details_1.vue?vue&type=style&index=0&id=e5b17c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b17c82",
  null
  
)

export default component.exports